// extracted by mini-css-extract-plugin
export default {"heading":"Title_heading__GR28-","extraSmall":"Title_extraSmall__APVDx","small":"Title_small__cqcgy","medium":"Title_medium__G1nXa","large":"Title_large__Y2tQB"};